import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface GetReactionsQuery {
  reactions: { id: string; value: string }[];
}

export type GetReactionsQueryVariables = Record<string, never>;

export const GET_REACTIONS: TypedDocumentNode<
  GetReactionsQuery,
  GetReactionsQueryVariables
> = gql`
  query GetReactions {
    reactions {
      id
      value
    }
  }
`;
